import Part from "@/components/body/parts/part";
import { Colors } from "@/components/shared/util";
import { Patient } from "@/store/modules/patient/types";
import _ from "lodash";
import SVG from "svg.js";
import { Store } from "vuex";
import { BodyConfig } from ".";

export default class LeftKidney extends Part {
  crrt!: SVG.Element;
  hemodialysis!: SVG.Element;

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
  }

  getExtraData(data: Patient) {
    this.extraData = {
      dialysis: _.get(data.body.atoms, "dialysis", null)
    };
  }

  updateData(patient: Patient | null) {
    super.updateData(patient);

    if (!this.crrt) {
      this.crrt = SVG.select("#crrt", this.container.node).first();
    }
    if (!this.hemodialysis) {
      this.hemodialysis = SVG.select(
        "#hemodialysis",
        this.container.node
      ).first();
    }

    this.crrt.hide();
    this.hemodialysis.hide();
    if (!patient) {
      return;
    }
    if (this.extraData.dialysis) {
      if (this.extraData.dialysis.alert === "CRRT") {
        this.crrt.show();
      } else if (this.extraData.dialysis.alert === "hemodialysis") {
        this.hemodialysis.show();
      }
    }
  }

  updateBrightnessMode() {
    if (this.dark) {
      this.hemodialysis.fill({ color: Colors.LightGray });
      this.crrt.fill({ color: Colors.LightGray });
    } else {
      this.hemodialysis.fill({ color: Colors.Black });
      this.crrt.fill({ color: Colors.Black });
    }
  }
}
